import {
  InlineRovoPromptTriggerSource,
  openInlineRovoPrompt,
} from '@databases/database-ai-first-creation-state/inline-rovo-prompt-state';
import { type defaultStoreUtils, type DefaultRootState } from '@databases/redux';
import { selectSelectedEntireFieldIds } from '@databases/redux/cellSelections/selectors';
import {
  doClearEntireFields,
  doDuplicateEntireFields,
  doMoveFields,
  doSelectNewFields,
} from '@databases/redux/contextual-menu/actions';
import { type DatabaseView } from '@databases/types/database/view';
import { getDatabaseFields } from '@databases/utils/database/utils';
import {
  type ViewChangeType,
  ViewChangeTypes,
} from '@databases/utils/database/view/view';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';

import { type SelectFieldActionsAPI } from './select-fields-actions';

type UseSelectFieldsActionsProps = {
  contentId: string;
  dispatch: ReturnType<typeof defaultStoreUtils.useDispatch>;
  view: DatabaseView;
  setViewChange: (view: ViewChangeType) => void;
  state: DefaultRootState;
};

export const buildSelectFieldsActionsForLegacyActionBar = ({
  contentId,
  dispatch,
  view,
  setViewChange,
  state,
}: UseSelectFieldsActionsProps): SelectFieldActionsAPI => {
  const handleDuplicateFields = () => {
    dispatch(
      doSelectNewFields(contentId, () =>
        dispatch(doDuplicateEntireFields(contentId, view.id))
      )
    );
  };

  const handleClearFields = () => {
    dispatch(doClearEntireFields(contentId));
  };

  const handleMoveFieldsLeft = () => {
    dispatch(doMoveFields(contentId, view.settings, true));
  };

  const handleMoveFieldsRight = () => {
    dispatch(doMoveFields(contentId, view.settings, false));
  };

  const handleHideFields = () => {
    const database = selectDatabaseByContentIdRequired(state, {
      contentId,
    });
    const fields = getDatabaseFields(database);
    const selectedEntireFieldIds = selectSelectedEntireFieldIds(state, {
      contentId,
    });

    selectedEntireFieldIds.forEach((selectedFieldId) => {
      const viewChange: ViewChangeType = {
        type: ViewChangeTypes.VIEW_FIELDS,
        fieldKey: selectedFieldId,
        fieldValue: false,
        fields,
      };

      setViewChange(viewChange);
    });
  };

  const handleAskRovo = () =>
    openInlineRovoPrompt(InlineRovoPromptTriggerSource.TableField);

  return {
    handleAskRovo,
    handleClearFields,
    handleDuplicateFields,
    handleHideFields,
    handleMoveFieldsLeft,
    handleMoveFieldsRight,
  };
};
